// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1XykA","header":"ReportDetails_header__1gKG9","title":"ReportDetails_title__2az3Z","left":"ReportDetails_left__sUaQ3"};